import { cvWebpFn } from './utils'

const webp = (el: HTMLImageElement) => {
  if(!IsWebp().value) return 

  if(el.nodeName === 'IMG') {
    el.src = cvWebpFn(el.src)
  } else { // 兼容第三方UI的Img组件
    const imgList = el.querySelectorAll('img')

    imgList.forEach((itemEl: any) => {
      if(itemEl.nodeName === 'IMG') {
        itemEl.src = cvWebpFn(itemEl.src)
      }
    })
  }
}


type IInput = HTMLInputElement | HTMLTextAreaElement
const specialChar = (el: IInput) => {
  let inputEl = el
  if(el.nodeName !== 'INPUT' && el.nodeName !== 'TEXTAREA') {
    inputEl = (el.querySelector('input') || el.querySelector('textarea')) as IInput
  }

  if(!inputEl) {
    return
  }

  inputEl.addEventListener('input', () => {
    const newValue = inputEl
    .value
      .replace(/[^!,@,#,$,%,^,&,\*,\(,\),\-,_,\+,=,{,},\[,\],;,'",:,<,>,\?,\/, ,，、。？！；：……“”（）【】a-zA-Z0-9₹€£¥°π%×÷\u4e00-\u9fa5]+/g, '') 
    
    if(inputEl.value !== newValue) {
      inputEl.value = newValue
      
      inputEl.dispatchEvent(new Event('input')) 
    }
  })
}


/**
 * 拓展指令 （ 因Server端也会解析， 所以不需要指定client ）
 */
export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.vueApp.directive('focus', { mounted (el) { el.focus() } })
  /**
   * 图片转webp，请注意使用懒加载时指令无效
   */
  NuxtApp.vueApp.directive('webp', { mounted: (el: any) => webp(el) })

  /**
   * 特殊字符
   */
  NuxtApp.vueApp.directive('special-char', { mounted: el => specialChar(el) })
})
